module.exports = __webpack_public_path__ + "static/img/banner.3ef27bc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/site-image/banner.png
// module id = IgE8
// module chunks = 169